import { render, staticRenderFns } from "./Cloudpods.vue?vue&type=template&id=10c48619&"
import script from "./Cloudpods.vue?vue&type=script&lang=js&"
export * from "./Cloudpods.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports